export const CREATE = 'create';
export const UPDATE = 'update';
export const DELETE = 'delete';
export const EVENT = 'event';

export const actions = [
  {
    key: CREATE,
    name: 'Criação',
    color: '#00B6AE',
  },
  {
    key: UPDATE,
    name: 'Alteração',
    color: '#5755d9',
  },
  {
    key: DELETE,
    name: 'Exclusão',
    color: '#e85600',
  },
  {
    key: EVENT,
    name: 'Evento',
    color: '#727e96',
  },
];

export function get(key) {
  return actions.find(item => item.key === key);
}

export function getName(key) {
  const action = get(key);
  return action ? action.name : key;
}

export function getColor(key) {
  const action = get(key);
  return action ? action.color : null;
}

export default actions;
